<template>
  <v-list>
    <u-file-item
      v-for="(file, key) in completed"
      :key="key"
      :uid="key"
      :item="file" />

    <u-file-item
      v-for="(file, key) in pending"
      :key="key"
      :uid="key"
      :item="file" />

    <u-file-item
      v-for="(file, key) in uploading"
      :key="key"
      :uid="key"
      :item="file" />

    <u-file-item
      v-for="(file, key) in canceled"
      :key="key"
      :uid="key"
      :item="file" />

    <u-file-item
      v-for="(file, key) in error"
      :key="key"
      :uid="key"
      :item="file" />
  </v-list>
</template>

<script>
/*
Files order from top to bottom:
  completed
  pending
  uploading
  canceled
  error
*/
import UFileItem from './UFileItem.vue'
import FILE_STATES from '../file-states.js'
import $state from '../upload-state.js'

export default {
  name: 'u-files-list',
  components: {'u-file-item': UFileItem},
  props: {
    filesByState: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      'FILE_STATES': FILE_STATES
    }
  },
  computed: {
    completed () {
      const completed = {}
      for (let key in this.filesByState.completed) {
        completed[key] = $state.files[key]
      }
      return completed
    },
    pending () {
      const pending = {}
      for (let key in this.filesByState.pending) {
        pending[key] = $state.files[key]
      }
      return pending
    },
    uploading () {
      const uploading = {}
      for (let key in this.filesByState.uploading) {
        uploading[key] = $state.files[key]
      }
      return uploading
    },
    canceled () {
      const canceled = {}
      for (let key in this.filesByState.canceled) {
        canceled[key] = $state.files[key]
      }
      return canceled
    },
    error () {
      const error = {}
      for (let key in this.filesByState.error) {
        error[key] = $state.files[key]
      }
      return error
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/uploader/components/UFilesList.vue